<template>
    <div>
        <!-- First Instragram Block -->
        <div class="block small instagram">
            <a :href="feeds[0].link" target="_blank" v-if="feeds[0]" v-lazy:background-image="feeds[0].image">
                <span class="title icon-instagram"></span>
            </a>
        </div>
        <!-- End First Instagram Block -->

        <!-- Second Instagram Block -->
        <div class="block small instagram">
            <a :href="feeds[1].link" target="_blank" v-if="feeds[1]" v-lazy:background-image="feeds[1].image">
                <span class="title icon-instagram"></span>
            </a>
        </div>
        <!-- End Second Instagram Block -->
    </div>
</template>

<script>
  import jsonp from 'jsonp'

  export default {
    props: {
      token: String,
      username: String
    },
    data () {
      return {
        feeds: [],
        profile: ''
      }
    },
    created () {
      // jsonp(`https://api.instagram.com/v1/users/self/media/recent/?access_token=${this.token}`, null, (derp, data) => {
      //   this.profile = data.data
      //   jsonp(`https://api.instagram.com/v1/users/self/media/recent?access_token=${this.token}&count=2`, null, (derp, data) => {
      //     this.feeds = data.data
      //   })
      // })

      window.api.get('get-insta').then(res => {
        this.token = res.data

        jsonp(`https://graph.instagram.com/me/media?fields=id,caption,media_url,media_type,thumbnail_url,permalink&access_token=${this.token}`, null, (derp, data) => {
          this.feeds = []
          for (let item of data.data) {
            if (item.media_type !== 'VIDEO') {
              this.feeds.push({link: item.permalink, image: item.media_url})
            }
          }
        })
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Instagram/Instagram.vue